// Angular Files
import { CommonModule, DOCUMENT, KeyValuePipe } from '@angular/common';
import { Component, NgModule, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';

// Angular Material Files
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule, MAT_LEGACY_DIALOG_DATA, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';

// Teller Online Library Files
import { TellerOnlineIconsModule } from "teller-online-libraries/icons";
// Deep-path imports break a shared barrel cycle (lib/components evaluates before
// lib/services, but message.service pulls in this file — barrel-importing back here
// crashes R3Injector under Vite ESM). Dialog model types are in a sibling .types file
// to avoid re-entering message.service. See TellerOnline.Frontend/CLAUDE.md.
import { TellerOnlineDialogOptions } from './dialog.types';
import { TellerOnlineValidationService } from '../../services/validation.service';
import { TellerOnlineWindowService } from '../../services/window.service';
import { DirectivesModule } from '../../directives/directives.module';
import { PipesModule } from '../../pipes/pipes.module';

@Component({
    selector: 'teller-online-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    host: {
        class: 'dialog'
    }
})
export class TellerOnlineDialogComponent implements OnInit, OnDestroy {
    public formData = {};
    public columnDefinitions = [];

    constructor(
        @Inject(MAT_LEGACY_DIALOG_DATA) public data: TellerOnlineDialogOptions,
        @Inject(DOCUMENT) public document: Document,
        public validationService: TellerOnlineValidationService,
        private windowService: TellerOnlineWindowService,
        private dialogRef: MatLegacyDialogRef<TellerOnlineDialogComponent>
    ) {
    }

    ngOnInit(): void {
        this.data.tables?.forEach(table => {
            let header = [];
            for (let i = 0; i < table.rows[0].length; i++) {
                header.push("column_"+i);
            }
            this.columnDefinitions.push(header);
        });

        // class added here to allow proper printing styling, removed in ngOnDestroy()
        this.document.querySelector("body").classList.add('dialog-opened');
    }

    ngOnDestroy(): void {
        this.document.querySelector("body").classList.remove('dialog-opened');
    }

    onClick_actionClose(closeModal: boolean, form: NgForm, callback: Function): void {
         if (callback) {
            callback();

            if (closeModal) {
                this.dialogRef.close(closeModal);
            }
        } else if(this.data.form && closeModal) {
            if(!this.validationService.runValidation(form))
                return;

            // update the close value to be the formdata
            this.dialogRef.close(this.formData);
        } else {
            this.dialogRef.close(closeModal);
        }
    }
}
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DirectivesModule,
        TellerOnlineIconsModule,
        MatLegacyDialogModule,
        MatLegacyButtonModule,
        MatLegacyFormFieldModule,
        MatLegacyInputModule,
        MatLegacySelectModule,
        MatTableModule,
        MatIconModule,
        KeyValuePipe,
        PipesModule
    ],
    declarations: [ TellerOnlineDialogComponent ],
    exports: [ TellerOnlineDialogComponent ]
})
export class TellerOnlineDialogModule { }
